@if (isInitialized && evcsComponent) {
  <oe-flat-widget [modalComponent]="modalComponent" style="cursor: pointer;"
    [title]="evcsComponent.alias" [icon]="{name: 'oe-evcs', color: 'normal'}">
    <!-- Show if Connection is Successful -->
    @if (isConnectionSuccessful) {
      <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.EVCS.STATUS'| translate" [value]="status" leftColumnWidth="20">
      </oe-flat-widget-line>
      <!-- Check if energy since beginning is allowed to be shown -->
      @if (isEnergySinceBeginningAllowed) {
        <oe-flat-widget-line
          [name]="'EDGE.INDEX.WIDGETS.EVCS.ENERGY_SINCE_BEGINNING' | translate"
          [channelAddress]="componentId + '/EnergySession'" [converter]="CONVERT_TO_KILO_WATTHOURS">
        </oe-flat-widget-line>
      }
      @if (isChargingEnabled && isReadWrite) {
        <oe-flat-widget-line [name]="'GENERAL.MODE'| translate" [value]="mode">
        </oe-flat-widget-line>
      }
      <!-- Show if charging is enabled -->
      @if (isChargingEnabled) {
        <!-- Show if chargeMode is EXCESS_POWER -->
        @if (chargeMode === 'EXCESS_POWER') {
          <!-- Show if defaultChargeMinPower greater 0 -->
          @if (defaultChargeMinPower > 0) {
            <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.EVCS.OPTIMIZED_CHARGE_MODE.MIN_CHARGING' | translate"
              [value]="'GENERAL.ACTIVE' | translate">
            </oe-flat-widget-line>
            <oe-flat-widget-line
              [name]="'EDGE.INDEX.WIDGETS.EVCS.OPTIMIZED_CHARGE_MODE.MIN_CHARGE_POWER' | translate"
              [converter]="CONVERT_WATT_TO_KILOWATT" [value]="defaultChargeMinPower" leftColumnWidth="50">
            </oe-flat-widget-line>
          }
          <oe-flat-widget-line leftColumnWidth="50" [name]="'EDGE.INDEX.WIDGETS.EVCS.PRIORITIZATION' | translate"
            [value]="prioritization | translate">
          </oe-flat-widget-line>
        }
        @if (chargeMode === 'FORCE_CHARGE') {
          <oe-flat-widget-line
            [name]="'EDGE.INDEX.WIDGETS.EVCS.FORCE_CHARGE_MODE.MAX_CHARGING' | translate"
            [converter]="CONVERT_WATT_TO_KILOWATT" [value]="maxChargingValue">
          </oe-flat-widget-line>
        }
        @if (energySessionLimit !== 0) {
          <oe-flat-widget-line
            [name]="'EDGE.INDEX.WIDGETS.EVCS.ENERGY_LIMIT' | translate" [converter]="CONVERT_TO_KILO_WATTHOURS"
          [value]="energySessionLimit"></oe-flat-widget-line>
        }
      }
    } @else {
      <oe-flat-widget-line leftColumnWidth="100"
        [name]="'EDGE.INDEX.WIDGETS.EVCS.NO_CONNECTION.DESCRIPTION' | translate">
      </oe-flat-widget-line>
    }
  </oe-flat-widget>
}
